import React from 'react';
import {
	 Select, Space, InputNumber
} from 'antd';

export default class SelectCricle extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            show: false,
            number: 1,
            sel: null
        };
    }

    componentDidMount(){
    }

    // 监听父组件传入的props改变
    componentWillReceiveProps(nextProps){
        let value  = nextProps.value; 

        if(value){
            let reg = /每([0-9]+)个月/g
            let res = reg.exec(value)
            if(res){
                let number =  res[1];
                this.setState((prev, props) => {
                    return { show: true, number: number, sel: '每_个月'}
                })
            }else {
                this.setState((prev, props) => {
                    return { show: false, sel: value, number: 1 }
                })
            }
        }
    }


    select = (value,index) => {
        if(value === '每_个月'){
            this.setState((prev, props) => {
                return { show: true , sel:value}
            })
        }else{
            this.setState((prev, props) => {
                return { show: false , sel:value}
            }, () => {
                if(this.props.onChange){
                    this.props.onChange(value);
                }
            })
        }
    };

    changeNum = (value) => {
        if(this.props.onChange && value){
            this.props.onChange(`每${value}个月`);
            this.setState({number: value})
        }
    };

    render(){
        const { disabled, bordered, placeholder,value } = this.props;
        let { show,sel,number } = this.state;
        return(
            <Space>
                <Select
                    value={sel}
                    disabled={disabled}
                    bordered={bordered}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    placeholder={placeholder}
                    onSelect={(value) => this.select(value)}
                >
                    <Select.Option value="每日">每日</Select.Option>
                    <Select.Option value="每周">每周</Select.Option>
                    <Select.Option value="每月">每月</Select.Option>
                    <Select.Option value="每季度">每季度</Select.Option>
                    <Select.Option value="每半年">每半年</Select.Option>
                    <Select.Option value="每年">每年</Select.Option>
                    <Select.Option value="每_个月">每_个月</Select.Option>
                    <Select.Option value="其他">其他</Select.Option>
                </Select>
                {
                    show &&
                    <InputNumber 
                        min={1}
                        disabled={disabled}
                        onChange={(value) => this.changeNum(value)} 
                        value={number}
                    />
                }
            </Space>
        )
    }
}


// WEBPACK FOOTER //
// app/components/customPage/project-manager/Pages/CusComponent.jsx